<template>
    <div id="header" class="clearfix" :class="!showNav ? 'hide-nav' : ''">
        <div class="rectbar">
            <div v-for="(x,i) in repetitions" :class="modeBgColor" :key="'bar_'+i" />
        </div>

        <div class="logo-etrainer">
            <a v-if="!isLoggedIn" :href="eTrainerLogoLink" target="_blank">
                <img :src="eTrainerLogo" alt="eTrainer Logo">
            </a>
            <a v-if="isLoggedIn" href="#" @click.prevent="goToHome">
                <img :src="eTrainerLogo" alt="eTrainer Logo">
            </a>
        </div>

        <div id="meta-nav-btn" class="uk-margin-top" @click="toggleMobileMenu">
            <a><span class="meta-nav-btn__icon" aria-hidden="true">☰</span> Menu</a>
        </div>

        <ul v-if="showNavLinks" class="meta-nav" :class="{ 'meta-nav--open': openMenu }">
            <li v-if="isLoggedIn">
                <a href="#" @click.prevent="goToHome">
                    Start
                </a>
            </li>
            <li v-if="isRealUser">
                <a href="#" @click.prevent="goToMyArea">
                    <img :src="myAreaIcon" alt="Zu meinem Bereich"> Mein Bereich
                </a>
            </li>
            <li v-if="showChatEntrypoints && isRealUser && !isChatParticipationExcluded">
                <a
                    :href="chatNavHref"
                    class="meta-nav-chat"
                    :aria-label="chatNavAriaLabel"
                    @click.prevent="openChatFromHeader"
                >
                    Chat
                    <span
                        v-if="!isInstitutionAttendee && mailboxNotificationCount > 0"
                        class="meta-nav-chat__badge"
                    >
                        {{ mailboxNotificationCount > 99 ? '99+' : mailboxNotificationCount }}
                    </span>
                </a>
            </li>
            <li v-if="showChatEntrypoints && !isLoggedIn">
                <a href="/chat/public#/chat/readonly">
                    Chat
                </a>
            </li>
            <li v-if="isRealUser && !isInstitutionAttendee">
                <a href="#" @click.prevent="goToShop">
                    Shop
                </a>
            </li>
            <li>
                <a :href="helpLink" target="_tab" @click="closeMobileMenu">Hilfe</a>
            </li>
            <li>
                <a href="//www.etrainer.de/kontakt/" target="_tab" @click="closeMobileMenu">Kontakt</a>
            </li>
            <li v-if="!isLoggedIn">
                <a href="/plus/verwaltung" target="_tab">ADMIN/TRAINER-LOGIN</a>
            </li>
            <li v-if="isRealUser">
                <a href="#" @click.prevent="logout">Logout</a>
            </li>
        </ul>

        <div class="logo-ap">
            <a href="//www.ausbildungspark.com" target="_blank">
                <img :src="APLogo" alt="Ausbildungspark Logo">
            </a>
        </div>
    </div>
</template>


<script>
    import Api from 'Ajax'
    import {imageUrls} from 'Shared'
    import {TestData, TestState, TestTemplate, MainCategories, SubCategories, Question, User, MarketingTexts} from 'Models'
    import { isChatParticipationExcludedAccount } from '@/common/chatParticipationExcluded'
    import {resetDefaultStore, setCurrentStorageUser, removeCurrentStorageUser} from '@/common/localStorage/currentStorageUser';
    import * as Sentry from "@sentry/vue";
    import IndexedDBManager from "@/common/indexedDB/IndexedDBManager";
    import { clearTestSession } from '@/pinia/testSession';
    import chatMailboxNotificationsMixin from '@/components/pages/chat/mixins/chatMailboxNotificationsMixin'
    import { debugMobileNav } from '@/common/debug/mobileNavDebug'

    // Livegang: Chat-Einstiege ausblenden. Zum Freischalten auf true setzen.
    const SHOW_CHAT_ENTRYPOINTS = true

    export default {
        mixins: [chatMailboxNotificationsMixin],
        props: {
            showNav:        { type: Boolean, default: true },
            showNavLinks:   { type: Boolean, default: true },
        },
        data(){
            return {
                openMenu: false,
            }
        },

        computed: {
            isInstitutionAttendee() {
                const isPlusLogin = this.$root.isLoginForInstitutionAttendees
                return (isPlusLogin && isPlusLogin()) ||
                       (User.exists() && User.current().belongsToInstitution())
            },
            isChatParticipationExcluded() {
                const isPlusLogin = this.$root.isLoginForInstitutionAttendees
                return (isPlusLogin && isPlusLogin()) || isChatParticipationExcludedAccount()
            },
            isInstitution() {
                const isAttendeesLogin = this.$root.isLoginForInstitutionAttendees
                return window.location.href.includes('plus/verwaltung') ||
                       (isAttendeesLogin && isAttendeesLogin())
            },
            isRealUser()    { return !this.isDemo && this.isLoggedIn },
            showChatEntrypoints() { return SHOW_CHAT_ENTRYPOINTS },
            APLogo()        { return imageUrls.logos.ausbildungspark },
            myAreaIcon()    { return imageUrls.navIcons.myAreaIconSmall },
            myAreaLink()
            {
                const userBelongsToInstitution = this.$root.userBelongsToInstitution;
                return userBelongsToInstitution && userBelongsToInstitution() ? '/plus#/myArea' : '/#/myArea'
            },
            eTrainerLogo()  {
                return this.isInstitution || this.isInstitutionAttendee
                       ? imageUrls.logos.etrainerPlus
                       : imageUrls.logos.etrainer
            },
            eTrainerLogoLink() {
                return this.isInstitution ? 'https://www.etrainer.de/plus' : 'https://www.etrainer.de'
            },
            eTrainerLogoLinkHome()
            {
                const userBelongsToInstitution = this.$root.userBelongsToInstitution;
                return userBelongsToInstitution && userBelongsToInstitution() ? '/plus' : '/'
            },
            helpLink() {
                return this.isInstitutionAttendee ? '//www.etrainer.de/plus/hilfe/' : '//www.etrainer.de/hilfe'
            },

            repetitions()   { return Array(6).fill(0) },
            chatNavHref() {
                return this.mailboxNotificationCount > 0 ? '/#/chat?mailbox=1' : '/#/chat'
            },
            chatNavAriaLabel() {
                const count = Number(this.mailboxNotificationCount || 0)
                if (count <= 0) {
                    return 'Chat'
                }

                return count === 1
                    ? 'Chat, 1 neue Benachrichtigung'
                    : `Chat, ${count} neue Benachrichtigungen`
            },
        },

        mounted() {
            Sentry.setUser({ email: User.current().email() })
        },

        beforeUnmount() {
            ;(this._mobileNavTimers || []).forEach((timerId) => clearTimeout(timerId))
            this._mobileNavTimers = []
        },

        methods: {
            canTrackMailboxNotifications() {
                return this.isRealUser && this.showChatEntrypoints && !this.isChatParticipationExcluded
            },
            toggleMobileMenu() {
                this.openMenu = !this.openMenu
                debugMobileNav('toggle mobile menu', { openMenu: this.openMenu })
            },
            closeMobileMenu() {
                if (!this.openMenu) {
                    return
                }

                this.openMenu = false
                debugMobileNav('close mobile menu')
            },
            navigateAfterMenuClose(navigate, label = 'unknown') {
                if (this._mobileNavPending) {
                    debugMobileNav('skip duplicate navigation', { label })
                    return
                }

                this._mobileNavPending = true
                window.dispatchEvent(new CustomEvent('etrainer-navigation-start', {
                    detail: { source: label },
                }))
                debugMobileNav('navigation scheduled', {
                    label,
                    from: this.$route?.name,
                })

                this.closeMobileMenu()

                const timers = this._mobileNavTimers || (this._mobileNavTimers = [])
                timers.push(window.setTimeout(() => {
                    debugMobileNav('navigation executing', {
                        label,
                        from: this.$route?.name,
                        openMenu: this.openMenu,
                    })

                    Promise.resolve()
                        .then(() => {
                            if (typeof navigate === 'function') {
                                return navigate()
                            }

                            return undefined
                        })
                        .catch((error) => {
                            console.error('[mobile-nav] navigation failed', { label, error })
                        })
                        .finally(() => {
                            if (typeof window === 'undefined') return
                            timers.push(window.setTimeout(() => {
                                this._mobileNavPending = false
                                if (typeof window === 'undefined') return
                                window.dispatchEvent(new CustomEvent('etrainer-navigation-end', {
                                    detail: { source: label },
                                }))
                                debugMobileNav('navigation finished', { label })
                            }, 150))
                        })
                }, 0))
            },
            goToHome() {
                this.navigateAfterMenuClose(() => {
                    if (this.$route?.name === 'dashboard') {
                        return undefined
                    }

                    return this.$router.push({ name: 'dashboard' })
                }, 'home')
            },
            goToMyArea() {
                this.navigateAfterMenuClose(() => {
                    const target = this.myAreaLink
                    if (String(target).startsWith('/plus')) {
                        window.location.href = target
                        return undefined
                    }

                    if (this.$route?.name === 'myarea') {
                        return undefined
                    }

                    return this.$router.push({ name: 'myarea' })
                }, 'my-area')
            },
            goToShop() {
                this.navigateAfterMenuClose(() => {
                    if (this.$route?.name === 'shop') {
                        return undefined
                    }

                    return this.$router.push({ name: 'shop' })
                }, 'shop')
            },
            openChatFromHeader() {
                this.navigateAfterMenuClose(() => {
                    if (!this.isChatParticipationExcluded && this.mailboxNotificationCount > 0) {
                        return this.openMailboxFromHeader()
                    }

                    if (this.$route?.name === 'chat') {
                        return undefined
                    }

                    if (this.$router) {
                        return this.$router.push({ name: 'chat' })
                    }

                    window.location.hash = '#/chat'
                    return undefined
                }, 'chat')
            },
            openMailboxFromHeader() {
                const alreadyOpen = this.$route?.name === 'chat'
                    && String(this.$route?.query?.mailbox || '') === '1'

                if (alreadyOpen) {
                    window.dispatchEvent(new CustomEvent('chat-open-mailbox'))
                    return
                }

                const query = this.$route?.name === 'chat'
                    ? { ...this.$route.query, mailbox: '1' }
                    : { mailbox: '1' }

                if (this.$router) {
                    const navigation = this.$router.push({ name: 'chat', query })
                    if (navigation && typeof navigation.catch === 'function') {
                        return navigation.catch(() => {})
                    }

                    return navigation
                }

                window.location.hash = '#/chat?mailbox=1'
                return undefined
            },
            async logout()
            {
                this.closeMobileMenu()
                const userBelongsToInstitution = this.$root.userBelongsToInstitution;
                const url = userBelongsToInstitution && userBelongsToInstitution() ? '/plus/logout' : '/logout'

                try {
                    await clearTestSession()
                } catch (e) {
                    console.warn('Could not clear the test session on logout', e)
                }

                removeCurrentStorageUser()
                resetDefaultStore()
                setCurrentStorageUser('')

                const audioDbManager = new IndexedDBManager('AudioRecorder')
                audioDbManager.init()
                    .then(() => audioDbManager.clearAll())

                location.replace(url)
            }
        }
    }
</script>


<style lang="scss">
    @use '~sass/variables' as *;

    .transition-hide {
        transition: top 300ms ease-out;
    }

    .hide-nav {
        top: -200px !important;
        position: absolute !important;
    }

    #header {
        transition: top 300ms ease-out;
        position: relative;
        padding:40px $app-right-margin 20px $app-left-margin;

        #meta-nav-btn { display: none; }

        .rectbar {
            position: absolute;
            right:0;
            top:0;
            width: 100%;
            height: 10px;
        }
        .rectbar > div {
            width:40px;
            height:10px;
            background: $testapp-primary;
            margin-left:10px;
            float:right;
        }
        .logo-etrainer img {
            width: 200px;
        }
        .logo-ap {
            position: absolute;
            right:20px;
            top:35px;
        }
        .logo-ap img {
             width: 100px;
        }

        .meta-nav {
            position: absolute;
            right: 190px;
            top: 50px;
            margin:0;

            > li {
                display: inline-block;
                list-style: none;
                margin-left: 25px;
                vertical-align: middle;

                &:first-child { margin-left: 0;}
            }
            > li a {
                white-space: nowrap;
                color: #000;
                text-transform: uppercase;
                font-size: 12px;
            }
            > li a:hover {
                color: $testapp-primary;
            }
        }

        .meta-nav-chat {
            position: relative;
            display: inline-block;
        }

        .meta-nav-chat__badge {
            position: absolute;
            top: -8px;
            right: -22px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: 999px;
            background: #dc2626;
            color: #ffffff;
            font-size: 10px;
            font-weight: 700;
            line-height: 16px;
            text-align: center;
            border: 1px solid #ffffff;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.25);
        }
    }

    @media screen and (max-width: 768px) {

        #header {
            padding: 30px 20px 15px 20px;
            z-index:90;
            background: #fff;
            box-sizing: border-box;

            #meta-nav-btn { display: block; }

            .rectbar {
                height: 8px;
            }

            .rectbar > div {
                width: 32px;
                height: 8px;
                margin-left: 8px;
            }

            .logo-ap {
                top:25px;
            }

            .logo-ap img {
                width: 80px;
            }
            .logo-etrainer img {
                width: 175px;
            }

            .meta-nav {
                display: none;
                position: relative;
                right: auto;
                top: auto;
                margin: 15px 0 0;
                padding: 0;

                &.meta-nav--open {
                    display: block;
                }

                > li {
                    display: block;
                    margin-left: 0;
                    border-bottom: 1px solid #ddd;

                    a {
                        display: block;
                        padding: 10px 0;
                        font-size: 14px;
                    }

                    a.meta-nav-chat {
                        display: inline-block;
                    }

                    img { display: none; }
                }
            }

            .meta-nav-btn__icon {
                display: inline-block;
                margin-right: 4px;
                font-size: 18px;
                line-height: 1;
            }
        }
    }
</style>